import React from 'react';
import { Button } from '@/components/ui/button';
import { BrowserCompatWrapper } from '@/components/ui/BrowserCompatWrapper';
import { canShowCloseButton, canShowResponderButton } from '../utils/notificationUtils';
import type { Notification } from '../types/notification.types';

interface NotificationActionsProps {
  notification: Notification;
  userRole: string;
  isUpdating: boolean;
  onButtonClick: (notification: Notification) => void;
  onResolveClick: (notification: Notification) => void;
}

export const NotificationActions: React.FC<NotificationActionsProps> = ({
  notification,
  userRole,
  isUpdating,
  onButtonClick,
  onResolveClick,
}) => {
  const canClose = canShowCloseButton(userRole, notification.originUserRole);
  const canRespond = canShowResponderButton(userRole, notification.targetUserRole);

  return (
    <div className="flex flex-col items-stretch justify-center p-6 min-w-[160px] gap-2">
      {/* Botones Resolver y Responder */}
      {notification.notificationStatusId === 1 && canRespond && (
        <BrowserCompatWrapper>
          <Button
            className="w-full bg-primary text-white px-4 py-2 rounded hover:bg-primary/80 transition-colors"
            onClick={() => onResolveClick(notification)}
            disabled={isUpdating}
          >
            Resolver
          </Button>
          <Button
            variant="outline"
            className="w-full px-4 py-2 rounded transition-colors"
            onClick={() => onButtonClick(notification)}
            disabled={isUpdating}
          >
            Responder ...
          </Button>
        </BrowserCompatWrapper>
      )}
      
      {/* Botón Cerrar */}
      {notification.notificationStatusId === 2 && canClose && (
        <Button
          className="bg-primary text-white px-4 py-2 rounded hover:bg-primary/80 transition-colors"
          onClick={() => onButtonClick(notification)}
          disabled={isUpdating}
        >
          Cerrar
        </Button>
      )}
    </div>
  );
}; 